<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="商品审核">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">Product Review</li>
        </ul>
      </template>
    </TitleCard>
    <div id="kt_app_main" class="app-main flex-column flex-row-fluid" v-loading="loading">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="" style="margin-bottom: 10px;padding: 0px 30px;">
          <div class="card card-flush">
            <div class="card-body">
              <div style="display: flex">
                <el-select placeholder="请选择审核状态" size="small" clearable v-model="params.status"
                           @change="statusChange">
                  <el-option label="待审核" value="0"/>
                  <el-option label="审核通过" value="1"/>
                  <el-option label="审核拒绝" value="2"/>
                </el-select>
                <el-input placeholder="请输入商品ID" v-model="params.id" clearable
                          style="margin-left: 10px;width: 300px" size="small" @change="statusChange"/>
                <el-input placeholder="请输入商品名称" v-model="params.title" clearable
                          style="margin-left: 10px;width: 300px" size="small" @change="statusChange"/>
                <el-input placeholder="请输入分类名称" v-model="params.categoryId1Name" clearable
                          style="margin-left: 10px;width: 300px" size="small" @change="statusChange"/>
                <el-input placeholder="请输入供应商名称" v-model="params.staffName" clearable
                          style="margin-left: 10px;width: 300px" size="small" @change="statusChange"/>
                <el-button style="margin-left: 10px" clearable round type="primary" size="small"
                           @click="getSjGoodsListAll">搜索
                </el-button>
                <el-button round size="small" @click="resetParams">重置</el-button>
                <el-button round size="small" @click="updateStatusBatchBtn" :disabled="multipleSelection.length == 0"
                           type="success">批量通过
                </el-button>
                <el-button round size="small" @click="downloadAllGoods"  icon="el-icon-download" :loading="downloadAllGoodsBtn"
                           type="primary">导出全部商品
                </el-button>
              </div>
              <el-table border :data="goodsList" style="margin-top: 20px" @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    :selectable="checkSelectable"
                    width="55">
                </el-table-column>
                <el-table-column label="商品ID" prop="id" width="100"/>
                <el-table-column label="供应商名称" prop="companyName"/>
                <el-table-column label="图片" width="100">
                  <template slot-scope="scope">
                    <el-image :src="scope.row.picUrl" alt="图片" :preview-src-list="[scope.row.picUrl]"/>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="title" width="300"/>
                <el-table-column label="分类" prop="categoryId1Name"/>
                <el-table-column label="销售价" prop="salePrice"/>
                <el-table-column label="结算价" prop="costPrice"/>
                <el-table-column label="审核状态">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 0" type="">待审核</el-tag>
                    <el-tag v-if="scope.row.status == 1" type="success">审核通过</el-tag>
                    <el-tag v-if="scope.row.status == 2" type="danger">审核拒绝</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div style="display: flex; justify-content: space-between; align-items: center">
                      <el-button type="primary" size="mini" @click="openDialog(scope.$index)">详情</el-button>
                      <el-button v-if="scope.row.status == 0" type="success" size="mini"
                                 @click="editPass(scope.row.id, 1)">通过
                      </el-button>
                      <el-button v-if="scope.row.status == 0" type="danger" size="mini"
                                 @click="updateStatus(scope.row.id, 2)">拒绝
                      </el-button>
                      <el-button v-if="scope.row.status == 1" type="danger" size="mini"
                                 @click="updateStatus(scope.row.id, 2)">强制下架
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="params.current"
                  :page-sizes="[10, 20, 30, 40, 100, 500]"
                  :page-size="params.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  style="display: flex;justify-content: center;margin-top: 20px">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="商品详情图" width="90%">
      <div v-if="selectedIndex >= 0">
        <div class="detail-img-style" v-html="goodsList[selectedIndex].detail"></div>
      </div>
    </el-dialog>

    <el-dialog v-if="editPassVisible" :close-on-click-modal="false" :visible.sync="editPassVisible"
               title="选择邮寄收费类型"
               width="20%">

      <div style="display: flex;justify-content: center;margin-top: 10px">

        <el-select v-model.number="isShip" placeholder="请选择">
          <el-option
              :value="1"
              label="厂家包邮">
          </el-option>
          <el-option
              :value="2"
              label="邮费自理">
          </el-option>
        </el-select>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-button type="primary" @click="updatePassStatus">确定</el-button>
      </div>

    </el-dialog>

    <el-dialog v-if="editPassVisibleBatch" :close-on-click-modal="false" :visible.sync="editPassVisibleBatch"
               title="选择邮寄收费类型"
               width="20%">

      <div style="display: flex;justify-content: center;margin-top: 10px">

        <el-select v-model.number="isShipBatch" placeholder="请选择">
          <el-option
              :value="1"
              label="厂家包邮">
          </el-option>
          <el-option
              :value="2"
              label="邮费自理">
          </el-option>
        </el-select>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-button type="primary" @click="updatePassStatusBatch">确定</el-button>
      </div>

    </el-dialog>


  </div>
</template>

<script>
import {
  getSjGoodsListAllApi,
  getSjGoodsListCountApi,
  goodsAuditExportApi,
  updateStatusApi,
  updateStatusBatch
} from "@/api/goodsManageApi";
import {getAccountInfo} from "@/api/PartnerAccountApi";
import {updateUserAgentApi} from "@/api/WxUserApi";
import sd from "silly-datetime";

export default {
  name: "ProductReview",
  data() {
    return {
      multipleSelection: [],
      dialogVisible: false,
      editPassVisibleBatch: false,
      params: {
        id: "",
        title: "",
        type: "1",
        isShow: "1",
        size: 10,
        current: 1,
        isJd: 2,
        status: "",
        categoryId1Name: "",
        staffName: "",
      },
      goodsList: [],
      loading: false,
      total: 0,
      selectedIndex: -1,
      editPassVisible: false,
      isShip: 1,
      isShipBatch: 1,
      passId: "",
      passStatus: "",
      downloadAllGoodsBtn: false,
    }
  },
  filters: {},
  methods: {
    updateStatusBatch,
    resetParams() {
      this.params = {
        id: "",
        title: "",
        type: "1",
        isShow: "1",
        size: 10,
        current: 1,
        isJd: 2,
        status: "",
        categoryId1Name: "",
        staffName: "",
      }
      this.getSjGoodsListAll()
    },
    updateStatusBatchBtn() {
      if (this.multipleSelection.length <= 0) {
        return
      }
      this.editPassVisibleBatch = true
      this.isShipBatch = 1

    },
    async downloadAllGoods(){
      this.downloadAllGoodsBtn = true
      let data = await goodsAuditExportApi();
      var blob = new Blob([data], {type: "application/octet-stream"});
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;

      a.download = `自有商品信息-${sd.format(new Date(), "YYYY-MM-DD")}.xlsx`; // 设置下载的文件名，根据需要修改
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.downloadAllGoodsBtn = false
    },
    async updatePassStatusBatch() {
      let isShip = this.isShipBatch
      let ids = this.multipleSelection.map(item => item.id)
      await updateStatusBatch({ids: ids, status: 1, isShip: isShip})
      await this.getSjGoodsListAll()
      this.$message({
        type: 'success',
        message: `通过成功！`
      });
      this.editPassVisibleBatch = false
      this.multipleSelection = []
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkSelectable(row, index) {
      return row.status == 0;
    },
    handleSizeChange(size) {
      this.params.size = size
      this.getSjGoodsListAll()
    },
    handleCurrentChange(current) {
      console.log(current)
      this.params.current = current
      this.getSjGoodsListAll()
    },
    async getSjGoodsListAll() {

      this.loading = true
      let {data} = await getSjGoodsListAllApi(this.params)
      this.goodsList = data.rows
      this.total = data.total
      this.loading = false
    },
    openDialog(index) {
      this.selectedIndex = index
      this.dialogVisible = true
    },
    async getSjGoodsPageCount() {
      let {data} = await getSjGoodsListCountApi(this.params);
      this.total = data;
    },
    async updateStatus(id, status) {
      await updateStatusApi({
        id,
        status
      })
      this.getSjGoodsListAll()
      this.$message({
        type: 'success',
        message: `${status == 2 ? '通过' : '拒绝'}成功！`
      });
    },
    async editPass(id, status) {
      this.editPassVisible = true
      this.passId = id
      this.passStatus = status
    },

    async updatePassStatus() {
      let id = this.passId
      let status = this.passStatus
      let isShip = this.isShip
      await updateStatusApi({
        id,
        status,
        isShip
      })
      this.getSjGoodsListAll()
      this.$message({
        type: 'success',
        message: `${status == 1 ? '通过' : '拒绝'}成功！`
      });
      this.editPassVisible = false
    },
    statusChange() {
      this.params.current = 1
    }

  },
  created() {
    this.getSjGoodsListAll()
  },
}
</script>

<style>
.detail-img-style {
  word-break: break-all;
  font-size: 14px;
}

.detail-img-style img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 10px auto;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

</style>
